import { ReactElement } from 'react';
import styled from 'styled-components';
import { PlainTextPopover } from './PlainTextPopover';
import { WithUncontrolledPopover } from './WithUncontrolledPopover';

const InlineAnchor = styled.span`
  display: inline-flex;
`;

/**
 * Wraps a trigger with a plain-text hover popover. When `popoverText` is
 * empty the child is rendered as-is (no wrapper). The inline-flex anchor
 * catches hover even when the trigger has `pointer-events: none` (e.g. a
 * disabled button), so the popover still opens.
 */
export const PlainTextPopoverTrigger = ({
  popoverText,
  children,
}: {
  popoverText?: string;
  children: ReactElement;
}): ReactElement =>
  popoverText ? (
    <WithUncontrolledPopover
      content={<PlainTextPopover>{popoverText}</PlainTextPopover>}
    >
      <InlineAnchor>{children}</InlineAnchor>
    </WithUncontrolledPopover>
  ) : (
    children
  );
